import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, adicionaIconesGrid, calculaAlturaGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-servico',
  templateUrl: './servico.component.html',
  styleUrls: ['./servico.component.css']
})
export class ServicoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  editOptionsGridServico = {
    mode: GridConfig.gridMode, // form
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Protocolo Tipo',
      showTitle: true
    }
  };

  listaUtilizacao = [
    { 'Id':  '0' , 'Descricao': 'Ambos' },
    { 'Id':  '1' , 'Descricao': 'Protocolo' },
    { 'Id':  '2' , 'Descricao': 'Ordem de Serviço' }
  ];

  colunasGridServico = null;
  servico = null;
  alturaGrid = null;

  constructor(@Inject(Http) http: Http) {
    this.servico = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/servico/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/servico/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/servico/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/servico/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridServico = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'DescricaoServico',
        dataType: 'string',
        caption: 'Descrição do Serviço',
        validationRules: [{
          type: 'required',
          message: 'Descrição do Serviço é obrigatória.'
        }]
      },
      {
        dataField: 'Utilizacao',
        dataType: 'string',
        caption: 'Utilização do serviço',
        validationRules: [{
          type: 'required',
          message: 'Utilização do serviço é obrigatória.'
        }],
        lookup: {
            dataSource: this.listaUtilizacao,
            displayExpr: 'Descricao',
            valueExpr: 'Id'
        }
      }
    ];
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/app/servico/servico.component.ts